import { Skeleton } from '@/src/components/Antd';
import { Icon } from '@/src/tools/icon';
import { useRequest } from 'ahooks';
import { get } from 'lodash';
import React from 'react';
import {
  Form,
  Modal,
  ModalFooter,
  RadioGroup,
  RadioItem,
} from 'src/components/Antd';
import Button from 'src/components/ClickableContainer';
import {
  ModalContent,
  SectionContainer as Section,
} from 'src/components/Layouts';
import { useSalesChannelType } from 'src/constrains/SalesChannelHOC/useSalesChannel';
import {
  getContentList,
  switchRecordedContent,
} from 'src/gql/salesChannelContentReverse';
import { useI18n } from 'src/hooks/useRouterChange';
import { graphql } from 'src/request';
import { i18nGet } from 'src/tools/tools';
import { ChannelType } from 'src/types/common/SalesChannel';
import { EnumSalesChannelMultiLanguage } from 'src/types/server/params';
import css from './css.module.less';

const ContentReverseIcon = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const [form] = Form.useForm();
  //const [versions, setVersions] = React.useState([]);
  const [showModal, setShowModal] = React.useState(false);
  const { onReload, entityType, salesChannelUuid, locale, entityUuid } = props;
  const type = useSalesChannelType();
  const isNotMini = type !== ChannelType.MiniProgram;
  const salesChannelMultiLanguageQueryParams = {
    [EnumSalesChannelMultiLanguage.multiLanguageInParams]: true,
    ...(isNotMini
      ? {
          [EnumSalesChannelMultiLanguage.siteStyleInParams]: true,
        }
      : {}),
    ...(isNotMini
      ? { [EnumSalesChannelMultiLanguage.siteStyleSizeInParams]: true }
      : {}),
    //  salesChannelMultiLanguageUpdate: true,
  };

  const {
    run: getList,
    data,
    loading,
  } = useRequest(
    () => {
      return graphql(getContentList, {
        entityUuid,
        salesChannelUuid,
        locale,
        entityType,
      });
    },
    {
      manual: true,
      // onSuccess: (data) => {
      //   const list = get(data, 'listContentVersions') || [];
      //   console.log('list', list);
      //   setVersions(list);
      // },
    },
  );
  const list = get(data, 'listContentVersions');

  const { run: onSwitch } = useRequest(
    (id, i18nUuid) => {
      return graphql(switchRecordedContent, {
        entityUuid,
        id,
        i18nUuid,
        entityType,
      });
    },
    {
      manual: true,
      onSuccess: () => {
        setShowModal(false);
        if (onReload) {
          onReload({ qParams: salesChannelMultiLanguageQueryParams });
        }
      },
    },
  );

  const radioGenerator = () => {
    return (list || []).map((i) => {
      const { id, version } = i;
      return (
        <RadioItem className={css.versionItem} value={id} key={id}>
          {getI18n('salesChannelContent.index.version')}
          {version}
        </RadioItem>
      );
    });
  };
  const handleOnCancel = () => {
    setShowModal(false);
  };

  return (
    <React.Fragment>
      {props.onlyText ? (
        <span
          onClick={(e) => {
            getList();
            setShowModal(true);
          }}>
          {getI18n('salesChannelContent.index.contentReverse')}
        </span>
      ) : (
        <Button
          className={css.iconContainer}
          onClick={(e) => {
            getList();
            setShowModal(true);
          }}
          title={getI18n('salesChannelContent.index.contentReverse')}>
          <Icon type={'iconinfo'} className={css.icon} />
        </Button>
      )}
      <Modal
        width={600}
        visible={showModal}
        title={getI18n('salesChannelContent.index.versionHistory')}
        onCancel={handleOnCancel}
        cancelText={getI18n('general.cancel')}>
        <React.Fragment>
          <Form
            form={form}
            onFinish={({ version }) => {
              const o = (list || []).find((i) => i.id === version);
              if (o) {
                onSwitch(o.id, o.i18nUuid);
              }
            }}>
            <ModalContent>
              <Section style={{ paddingTop: 0 }} className={css.section}>
                <Skeleton loading={loading} active>
                  <Form.Item
                    name={'version'}
                    rules={[
                      {
                        required: true,
                        message: getI18n(
                          'salesChannelContent.index.pleaseselectarecordedversion',
                        ),
                      },
                    ]}>
                    <RadioGroup className={css.group}>
                      {radioGenerator()}
                    </RadioGroup>
                  </Form.Item>
                </Skeleton>
              </Section>
            </ModalContent>

            <Form.Item
              shouldUpdate={(p, c) => {
                const epV = get(p, 'version');
                const ecV = get(c, 'version');

                return epV !== ecV;
              }}>
              {({ getFieldValue }) => {
                const v = getFieldValue('version');
                return (
                  <ModalFooter
                    onCancel={() => {
                      setShowModal(false);
                    }}
                    hideOkButton={!v}
                    onOk={() => {
                      form.submit();
                      //setShowModal(false);
                    }}
                    okText={getI18n('general.continue')}
                  />
                );
              }}
            </Form.Item>
          </Form>
        </React.Fragment>
      </Modal>
    </React.Fragment>
  );
};
export default ContentReverseIcon;
